import { getConfidenceColor } from '../../../../../logger/screens/stream/components/audit/transcriptions/utils';
import {
  ElasticSearchFormattedType,
  ElasticSearchResponse,
  ElasticSearchType,
} from '../../../../types';
import { HighlightedText } from './HighlightedText';

export const parseTranscriptionSearch = (data: ElasticSearchResponse[]): ElasticSearchType[] => {
  const array = data.map((item) => {
    return {
      elastic_data: item[0].elastic_data,
      highlight: item[0].highlight,
      length: item[0].length,
      tags: item[0].tags,
      time: item[0].time,
      wp_words: item[0].wp_words,
    };
  });
  return array;
};

export const formatTranscript = (
  data: ElasticSearchType[],
  filterWords?: string[],
): ElasticSearchFormattedType[] => {
  const formattedText = data.map((item) => {
    const rawContent = item.wp_words.map((wpWord) => wpWord.word).join(' ');
    return {
      highlight: item.highlight,
      length: item.length,
      tags: item.tags,
      time: item.time,
      raw_content: <HighlightedText highlightWords={filterWords} text={rawContent} />,
      wp_words: item.wp_words.map((text) => {
        return (
          <span style={{ backgroundColor: getConfidenceColor(text.confidence) }}>{text.word}</span>
        );
      }),
    };
  });
  return formattedText;
};
